var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUniversityGraduate = function SvgUniversityGraduate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "school"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_404_10117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_404_10117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "school_2",
    d: "M21.7033 16.6124V9.83732L12.4593 14.8612C12.1148 15.0526 11.7512 15.1483 11.3684 15.1483C10.9856 15.1483 10.622 15.0526 10.2775 14.8612L0.574163 9.57895C0.363636 9.46412 0.215311 9.32058 0.129187 9.14833C0.0430622 8.97608 0 8.78469 0 8.57416C0 8.36364 0.0430622 8.17225 0.129187 8C0.215311 7.82775 0.363636 7.68421 0.574163 7.56938L10.2775 2.28708C10.4498 2.19139 10.6268 2.11962 10.8086 2.07177C10.9904 2.02392 11.177 2 11.3684 2C11.5598 2 11.7464 2.02392 11.9282 2.07177C12.11 2.11962 12.2871 2.19139 12.4593 2.28708L23.3971 8.25837C23.5885 8.35407 23.7368 8.49282 23.8421 8.67464C23.9474 8.85646 24 9.05263 24 9.26316V16.6124C24 16.9378 23.89 17.2105 23.6699 17.4306C23.4498 17.6507 23.177 17.7608 22.8517 17.7608C22.5263 17.7608 22.2536 17.6507 22.0335 17.4306C21.8134 17.2105 21.7033 16.9378 21.7033 16.6124ZM10.2775 21.7512L4.53588 18.6507C4.15311 18.4402 3.85646 18.1531 3.64593 17.7895C3.43541 17.4258 3.33014 17.0335 3.33014 16.6124V12.2488L10.2775 16.0096C10.622 16.201 10.9856 16.2967 11.3684 16.2967C11.7512 16.2967 12.1148 16.201 12.4593 16.0096L19.4067 12.2488V16.6124C19.4067 17.0335 19.3014 17.4258 19.0909 17.7895C18.8804 18.1531 18.5837 18.4402 18.201 18.6507L12.4593 21.7512C12.2871 21.8469 12.11 21.9187 11.9282 21.9665C11.7464 22.0144 11.5598 22.0383 11.3684 22.0383C11.177 22.0383 10.9904 22.0144 10.8086 21.9665C10.6268 21.9187 10.4498 21.8469 10.2775 21.7512Z",
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUniversityGraduate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/university_graduate.f1f8b79e.svg";
export { ForwardRef as ReactComponent };